<template>
    <div id="layout">
        <div id="content">
            <Menu></Menu>
            <div class="page-content">
                <div id="linkList">
                    <ul class="header-ul"  v-if="working == 0">
                        <li class="header stoned">
                            <span v-for="(column, key) in table.columns" v-bind:key="key" :class="column[1]">
                                <template v-if="table.sort_key === key">
                                    <a class="search-order" v-show="table.reverse === 1">&#8593;</a>
                                    <a class="search-order" v-show="table.reverse === -1">&#8595;</a>
                                </template>
                                <a v-on:click="nowSort(key)">{{column[0]}}</a>
                            </span>
                        </li>
                        <li class="searchbox">
                                <span class="five">
                                    <search-input v-model="search_string"></search-input>
                                </span>
                            <span class="one"></span>
                            <span class="one">Total: {{filteredErrors.length}}</span>
                        </li>
                    </ul>
                    <ul>
                        <li v-if="working > 0"><div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div></li>
                        <template v-else>
                            <li v-for="error in filteredErrors">
                                <span class="one">{{error.host}}</span>
                                <span class="two">
                                    <a target="_blank" :href="error.URL">{{error.URL}}</a>
                                    <copy-link v-bind:text-to-copy="error.URL"></copy-link>
                                </span>
                                <span class="two">
                                    <a target="_blank" :href="error.source_URL">{{error.source_URL}}<external-link-icon></external-link-icon></a>
                                    <copy-link v-bind:text-to-copy="error.source_URL"></copy-link>
                                </span>
                                <span class="cent one"><strong>{{error.http_status}}</strong></span>
                                <span class="one">{{error.error}}</span>
                            </li>
                            <li v-if="(filteredErrors.length === 0) && (working === 0)" class="no-data"><span>No data</span><span>No data</span><span>No data</span><span>No data</span><span>No data</span></li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import Storages from 'js-storage'

    import config from '@/config'

    import Menu from '@/components/small/Menu'
    import SearchInput from '@/components/small/SearchInput'
    import CopyLink from "@/components/UI/_base-UI-CopyLink";

    import { ExternalLinkIcon } from 'vue-feather-icons'

    export default {
        name: "Errors",
        components:{
            CopyLink,
            Menu,
            SearchInput,
            ExternalLinkIcon
        },
        data: function (){
            return {
                table:{
                    reverse: Storages.localStorage.isSet('reverse')?Storages.localStorage.get('reverse'):1,
                    sort_key: Storages.localStorage.isSet('sort_key')?Storages.localStorage.get('sort_key'):'host',
                    columns: {
                        'host': ['Host', 'one'],
                        'URL' : ['URL', 'two'],
                        'source_URL': ['Found on URL', 'two'],
                        'http_status': ['HTTP Status', 'one cent'],
                        'error': ['Error', 'one'],
                    }
                },
                working: 0,
                errors: [],
                search_string: ""
            }
        },
        computed: {
            filteredErrors: function () {
                let newErrors = this.errors.filter( (err) => {
                    return Object.keys(err).some( (key) => {
                        return String(err[key]).toLowerCase().indexOf(this.search_string) > -1
                    })
                })

                return  newErrors.sort( (a, b) => {
                    a = a[this.table.sort_key]
                    b = b[this.table.sort_key]
                    return (a === b ? 0 : a > b ? 1 : -1) * this.table.reverse;
                })
            }
        },
        mounted: function(){
            this.getErrors();
        },
        methods: {
            nowSort: function (new_key){
                if (this.table.sort_key == new_key){
                    this.table.reverse = -1*this.table.reverse;
                }else{
                    this.table.sort_key = new_key;
                    this.table.reverse = 1;
                }
                Storages.localStorage.set('sort_key', this.table.sort_key);
                Storages.localStorage.set('reverse', this.table.reverse);
            },
            getErrors: async function () {
                this.errors = [];
                this.working++;
                let request_url = config.api_url + '/?op=errors';
                axios
                    .get(request_url)
                    .then(response => {
                        this.errors = response.data;
                        this.working--;
                    })
                    .catch(error => {
                        console.log(error)
                        this.working--;
                    });
            },
            copyURL: function(url){
                copyToClipboard(url);
            }
        }
    }
</script>
<style scoped>

    #content{
        flex-direction: column;
    }

    ul li a{
        color: #4e4872;
    }

    #linkList #list-wrap{
        max-height: 80%;
    }

    #linkList{
        box-sizing: border-box;
        background: #CCCCCC;
        width: 100%;
        height: 100%;
        border-right: 2px solid #b1b1b1;
        border-top: 2px solid #FFFFFF;
        border-bottom: 2px solid #656565;
        border-left: 2px solid #656565;
        box-shadow: 0px 0px 1px 1px #471932;
        display: flex;
        flex-direction: column;
    }

    ul li{
        list-style: none;
        display: flex;
        flex-wrap: nowrap;
        border-top: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
        background: #dfdfdf;  /* fallback for old browsers */
        padding: 0.5rem;
        color: #000000;
        border-bottom: 1px solid #888;
        border-left: 1px solid #888;
        text-shadow: none;
    }


    ul li.root{
        list-style: none;
        display: flex;
        flex-wrap: nowrap;
        border-top: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
        background: #ffe986;  /* fallback for old browsers */
        padding: 0.5rem;
        color: #000000;
        border-bottom: 1px solid #888;
        border-left: 1px solid #888;
        text-shadow: none;
    }

    ul li.no-data{
        color: #a9a9a9;
        text-align: center;
        text-shadow: 1px 1px 0px #FFF;
    }

    ul li .shadow{
        color: #b9b9b9;
    }

    .lds-ellipsis {
        text-align: center;
        display: block;
        position: relative;
        width: 64px;
        height: 64px;
        margin: auto;
    }
    .lds-ellipsis div {
        position: absolute;
        top: 27px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: #93291E;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis div:nth-child(1) {
        left: 6px;
        animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
        left: 6px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
        left: 26px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
        left: 45px;
        animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }
    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(19px, 0);
        }
    }
</style>
